import { render, staticRenderFns } from "./ServiceTypeSelect.vue?vue&type=template&id=cb5191d4&"
import script from "./ServiceTypeSelect.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports